import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InvitationService {
    /**
     * Accept invitation by the id
     * @param id
     * @param requestBody
     * @returns InvitationBoInterface
     * @throws ApiError
     */
    static invitationAcceptInvitation(id, requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invitation/{id}/accept',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Accept invitation by the id
     * @param id
     * @returns InvitationBoInterface
     * @throws ApiError
     */
    static invitationDeclineInvitation(id) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invitation/{id}/decline',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get invitation by id with company info
     * @param id
     * @returns CompanyInvitationBoInterface
     * @throws ApiError
     */
    static invitationFindById(id) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invitation/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get invitation by email with company info
     * @param email
     * @returns CompanyInvitationBoInterface
     * @throws ApiError
     */
    static invitationFindByEmail(email) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/invitation/email/{email}',
            path: {
                'email': email,
            },
        });
    }
    /**
     * Get all invitations by query
     * @param requestBody
     * @returns InvitationBoInterface
     * @throws ApiError
     */
    static invitationFindByQuery(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/invitation/query',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
